import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";

import { type IoniconIconName } from "@/schemas/icons";

type AttributeTagProps = {
  icon: IoniconIconName;
  iconColor: string;
  text: string;
  backgroundColor: string;
  onPress?: () => void;
};

function AttributeTag({
  icon,
  iconColor,
  text,
  backgroundColor,
  onPress,
}: AttributeTagProps): React.JSX.Element {
  return (
    <TouchableOpacity disabled={onPress === null} onPress={onPress}>
      <View style={[styles.container, { backgroundColor }]}>
        <Ionicons name={icon} size={16} color={iconColor} style={styles.icon} />
        <Text style={[styles.text]}>{text}</Text>
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    borderRadius: 20,
    flexDirection: "row",
    marginBottom: 8,
    marginRight: 8,
    padding: 8,
  },
  icon: {
    marginRight: 4,
  },
  text: {
    color: "white",
    fontSize: 16,
  },
});

export default AttributeTag;
